import { useQuery } from "react-query";
import { supportWidgetApi } from "@circle-react/api/supportWidgetApi";
import {
  FIFTEEN_MINUTES,
  HELP_WIDGET_LOCATION_LOCAL_STORAGE_KEY,
} from "../constants";

const handleOnError = () => {
  localStorage.setItem(HELP_WIDGET_LOCATION_LOCAL_STORAGE_KEY, "/");
};

export const useShowPost = (id: string | number) =>
  useQuery(["posts", "details", id], () => supportWidgetApi.showPost(id), {
    onError: handleOnError,
    retry: false,
    staleTime: FIFTEEN_MINUTES,
  });
